import { proximaApi } from '../proximaApi'
import { type GoogleAuthentication } from '../schema-dtos/LegacyTwoFADomainDtos'

const SUB_URL = '/authentication/two-fa'

export const twoFAApi = proximaApi.injectEndpoints({
  endpoints: (builder) => ({
    generateSecret: builder.mutation<GoogleAuthentication, Partial<void>>({
      query: () => ({
        url: `${SUB_URL}/generate`,
        method: 'POST'
      })
    }),
    enableTwoFA: builder.mutation({
      query: (body) => ({
        url: `${SUB_URL}/enable`,
        method: 'POST',
        body
      })
    }),

    generateAndSendOtp: builder.mutation({
      query: (assetHolderId: number) => ({
        url: `${SUB_URL}/asset-holders/${assetHolderId}/otp`,
        method: 'POST'
      })
    })
  }),

  overrideExisting: false
})

export const useTwoFAApiGenerateSecretMutation = twoFAApi.endpoints.generateSecret.useMutation
export const useTwoFAApiEnableTwoFA = twoFAApi.endpoints.enableTwoFA.useMutation

export const generateAndSendOtpMutation = twoFAApi.endpoints.generateAndSendOtp.useMutation
